import { lazy, Suspense } from 'react';
import { Scene } from '@/render/Canvas';
import { useTourStore } from '@/state/tour';
import { Overlay } from '@/ui/Overlay';
import { ScrollTrack } from '@/ui/ScrollTrack';

const DevPanel = lazy(() => import('@/dev/DevPanel'));

export function App() {
  const dev = useTourStore((s) => s.dev);
  return (
    <>
      <Scene />
      <ScrollTrack />
      <Overlay />
      {dev && (
        <Suspense fallback={null}>
          <DevPanel />
        </Suspense>
      )}
    </>
  );
}
